import gql from 'graphql-tag';

export default gql`
  mutation cancelRsvpCollegeFair($input: cancelRsvpCollegeFairInput!) {
    cancelRsvpCollegeFair(input: $input) {
      collegeFair {
        id
        attending
        version
        status
        highSchool {
          id
          viewerRepVisitsEvents {
            id
            userBookingStatus
          }
        }
      }
    }
  }
`;
